<template>
    <b-container fluid>
        
            <PortalNavbar show="true"></PortalNavbar>
        
        <section class="about_area row" style="margin-left:50px;">
            <div class="container">
                 <!--<div class="tittle wow fadeInUp">
                <h2>ABOUT US</h2>
               
            </div>-->
            <div class="row about_row">
                <div class="col-md-12">
                    <div class="" style="float:right;margin-right:50px;">
                      <!--
                    <img src="@/assets/images/guards.jpg" class="img-responsive"><br/>
                    <img src="@/assets/images/guards4.jpg" class="img-responsive"><br/>-->
                    <img src="@/assets/images/about_us.png" alt=""><br/>
                    <img src="@/assets/images/about_us_SB.png" alt="" ><br/>

                    

                 </div>
                    <div class="subtittle">
                        <h2 style="color:#ec5624;">ABOUT US</h2>
                    </div>

                    <p style="margin-right:50%;">

 During the year 1980-81, the Maharashtra Rajya Suraksha Rakshak and General Kamgar Union had represented to Government that about 70,000 persons are working as Security Guards in various Factories and Establishments in Greater Bombay and Thane District. These Guards are provided by Security Agencies operating in these Areas. The service conditions, however of these Security Guards are not satisfactory and these Security Guards are being exploited in as much as that their services depend merely on the whim and sweetwill of the Agencies. Most of the Security Guards receive very small portion of the amount recovered from the Employers as their wages and the balance is pocketed by the Agencies.<br/><br/>


 
 The Government therefore conducted a rapid survey through the Office of the Commissioner of Labour and the findings of the said survey confirmed that there is substantial truth in the representation. It was also noticed that the Security Guards were not entitled to any protection of the Labour Laws available to the other workers of the Factories and Establishments.<br/><br/>


 
 In order to ensure that the Security Guards in Factories/Establishments are not exploited and for making better provisions for their terms and conditions of employment and welfare through the establishment of the Board, the Government thought it necessary to enact a Special Law immediately on the lines of the Maharashtra Mathadi Hamal & other Mannual Workers (Regulation of Employment & Welfare) Act, 1969, which would make possible in due course of time to make recruitment of the Security Guards through the Board only.<br/><br/>


 
 A Bill for regulating the employment of Private Security Guards employed in Factories/Establishments in the State of Maharashtra and for making better provisions for their terms and conditions of employment and welfare through the establishment of the Board was moved by the Government and was passed by both Houses on 31st August, 1981 and the assent of the President was received on 25th September, 1981, converting the Maharashtra Private Security Guards (Regulation of Employment and Welfare) Ordinance, 1981 into the Mahrashtra Private Security Guards (Regulation of Employment and Welfare) Act, 1981, with retrospective effect from 29th June, 1981.<br/><br/>


 
 The scope of the Act extends to the whole State of Maharashtra however, initially the scope of the Act was restricted only to Greater Bombay and Thane District. The Act applies to persons who work as Security Guards in any Factory or Establishment through Agencies but it does not apply to persons who are direct and regular employees of the Factory or Establishment.<br/><br/>


 
 The scope of the Act is further extended to the Pune, Raigad, Nasik, Aurangabad and Nagpur Districts vide Government Notification dated 05.12.2002 and Districtwise Boards have been constituted at the said areas w.e.f. 06.02.2003.<br/><br/>


 
 Under the said Act and Scheme known the Private Security Guards (Regulation of Employment and Welfare) Scheme, 1981 was published on 31st August, 1981. However, 144 Agencies and about 664 Principal Employers filed Writ Petitions in the High Court challenging the constitutional validity of this Act and the Scheme framed thereunder. As a result large number of Principal Employers who were amenable for Registration under Clause 14 of the Scheme were not registered with the Board. This adversely affected the working of the Board. The flow of Petitions continued from September, 1981 to March, 1982. By the Judgement delivered by Mr. Justice P.B.Sawant on 2nd November, 1982, the validity of the said Act and the said Scheme was upheld.<br/><br/>


 
 The abovesaid Act was amended on 29th April, 1996, whereby, the definition of 'Employer' was amended as 'Principal Employers' and 'Agency' or'Agent' which employ a Security Guard and deploy in a factory or establishment was introduced as 'Employer Agency'.</p><br/>
                    </div>

            </div>
            </div>
        </section>
    </b-container>
</template>

<script>
import PortalNavbar from "@/components/PortalNavbar";
export default {
components: { PortalNavbar}
}
</script>

<style scoped>

.about_area .about_row {
  padding-top: 70px;
  padding-bottom: 70px;
}
.about_area .about_row p {
  font: 400 14px/26px "Open sans", sans-serif;
  color: #555555;
  padding-top: 28px;
  padding-bottom: 54px;
}
.subtittle h2 {
  font: 700 36px "Open sans", sans-serif;
  color: #222222;
  text-transform: uppercase;
  position: relative;
  margin-bottom: 20px;
}
.subtittle h2:after {
  content: "";
  position: absolute;
  height: 2px;
  width: 120px;
  background: #222222;
  left: 0;
  bottom: -22px;
}
</style>



// WEBPACK FOOTER //
// src/components/Portal/About.vue